import React, { useEffect, useState } from "react";
import { RefreshCw, RotateCcw } from "lucide-react";
import AdminLayout from "./AdminLayout";
import API from "../services/api";

function AdminBidRevert() {
  const [bets, setBets] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadBets = async () => {
    try {
      setLoading(true);
      const res = await API.get("/admin/bets?status=pending");
      setBets(Array.isArray(res.data) ? res.data : []);
    } catch {
      setBets([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadBets();
  }, []);

  const revertBet = async (id) => {
    try {
      await API.post(`/admin/bets/${id}/revert`);
      await loadBets();
    } catch (err) {
      alert(err?.response?.data?.message || "Unable to revert bid");
    }
  };

  return (
    <AdminLayout>
      <section style={page}>
        <div style={header}>
          <div>
            <h1 style={title}>Bid Revert</h1>
            <p style={subtitle}>Pending bids only. Reverting returns points to the user wallet.</p>
          </div>
          <button type="button" style={refreshButton} onClick={loadBets}>
            <RefreshCw size={16} /> {loading ? "Loading..." : "Refresh"}
          </button>
        </div>

        <section style={tableCard}>
          <table style={table}>
            <thead>
              <tr>
                <th style={th}>ID</th>
                <th style={th}>User</th>
                <th style={th}>Market</th>
                <th style={th}>Type</th>
                <th style={th}>Number</th>
                <th style={th}>Amount</th>
                <th style={th}>Date</th>
                <th style={{ ...th, textAlign: "right" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {bets.map((bet) => (
                <tr key={bet.id}>
                  <td style={td}>{bet.id}</td>
                  <td style={td}>
                    <strong style={userName}>{bet.user_name || `User ${bet.user_id}`}</strong>
                    <span style={userPhone}>{bet.user_phone || "-"}</span>
                  </td>
                  <td style={td}>{bet.market_name || "-"}</td>
                  <td style={td}>{prettyType(bet.type)}</td>
                  <td style={td}>{bet.number}</td>
                  <td style={td}><strong>Rs {Number(bet.amount || 0)}</strong></td>
                  <td style={td}>{formatDateTime(bet.date || bet.created_at)}</td>
                  <td style={{ ...td, textAlign: "right" }}>
                    <button type="button" style={revertButton} onClick={() => revertBet(bet.id)}>
                      <RotateCcw size={15} /> Revert
                    </button>
                  </td>
                </tr>
              ))}
              {!bets.length && (
                <tr>
                  <td style={emptyCell} colSpan={8}>No pending bids found</td>
                </tr>
              )}
            </tbody>
          </table>
        </section>
      </section>
    </AdminLayout>
  );
}

function prettyType(value = "") {
  return String(value || "-").replace(/[-_]/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
}

function formatDateTime(value) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return `${date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}, ${date.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}`;
}

const page = { display: "grid", gap: "18px" };
const header = { display: "flex", justifyContent: "space-between", alignItems: "flex-start" };
const title = { margin: 0, fontSize: 22, fontWeight: 800, color: "#1e1b4b" };
const subtitle = { margin: "6px 0 0", color: "#64748b", fontSize: "13px" };
const refreshButton = { height: "44px", padding: "0 16px", border: "1px solid #dbe4f0", background: "#fff", borderRadius: "12px", display: "flex", alignItems: "center", gap: "8px", fontWeight: 700, cursor: "pointer" };
const tableCard = { background: "#fff", border: "1px solid #e2e8f0", borderRadius: "18px", overflow: "auto" };
const table = { width: "100%", minWidth: "980px", borderCollapse: "collapse" };
const th = { height: "48px", padding: "0 18px", textAlign: "left", color: "#64748b", fontSize: "11px", textTransform: "uppercase", borderBottom: "1px solid #e5e7eb" };
const td = { padding: "15px 18px", borderBottom: "1px solid #f1f5f9", color: "#0f172a", fontSize: "13px" };
const userName = { display: "block", fontSize: "14px", fontWeight: 800 };
const userPhone = { display: "block", marginTop: "3px", color: "#64748b", fontSize: "12px" };
const revertButton = { height: "36px", padding: "0 12px", border: 0, borderRadius: "10px", background: "#fee2e2", color: "#dc2626", display: "inline-flex", alignItems: "center", gap: "7px", fontWeight: 800, cursor: "pointer" };
const emptyCell = { padding: "36px", textAlign: "center", color: "#94a3b8" };

export default AdminBidRevert;
